import type { MonteCarloResult } from '../utils/financialCalculations';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, ReferenceLine, CartesianGrid } from 'recharts';

export default function PaybackRiskChart({ monteCarlo, printMode }: { monteCarlo: MonteCarloResult; printMode?: boolean }) {
  const { paybackP10, paybackP50, paybackP90, paybacks } = monteCarlo;
  const validPaybacks = paybacks.filter((p): p is number => p !== null);
  if (validPaybacks.length === 0) return (
    <div className="bg-white rounded-xl border border-[#D9E2EC] p-4 shadow-sm mb-4">
      <div className="text-xs font-bold text-[#0B1F4A] mb-1">⏱️ Terugverdientijd Risicobanden</div>
      <div className="text-[10px] text-[#991B1B]">Geen terugverdientijd gevonden</div>
    </div>
  );
  const maxYear = Math.ceil(Math.max(...validPaybacks));
  const bins = Array.from({ length: maxYear + 1 }, (_, y) => {
    const count = validPaybacks.filter(p => Math.floor(p) === y).length;
    return { year: y, count, pct: +(count / validPaybacks.length * 100).toFixed(1) };
  });
  return (
    <div className="bg-white rounded-xl border border-[#D9E2EC] p-4 shadow-sm mb-4">
      <div className="text-xs font-bold text-[#0B1F4A] mb-1">⏱️ Terugverdientijd — Risicobanden</div>
      <div className="text-[10px] text-[#8899AA] mb-3">P10: {paybackP10?.toFixed(1) ?? '–'}j | P50: {paybackP50?.toFixed(1) ?? '–'}j | P90: {paybackP90?.toFixed(1) ?? '–'}j</div>
      <div className="grid grid-cols-3 gap-2 mb-3">
        <div className="bg-[#F0FDF4] rounded-lg p-2 border border-[#BBF7D0] text-center"><div className="text-[9px] text-[#166534] font-semibold">P10</div><div className="text-base font-bold text-[#166534]">{paybackP10?.toFixed(1) ?? '–'} jaar</div></div>
        <div className="bg-[#FFF7ED] rounded-lg p-2 border border-[#FED7AA] text-center"><div className="text-[9px] text-[#9A3412] font-semibold">P50</div><div className="text-base font-bold text-[#9A3412]">{paybackP50?.toFixed(1) ?? '–'} jaar</div></div>
        <div className="bg-[#FEF2F2] rounded-lg p-2 border border-[#FECACA] text-center"><div className="text-[9px] text-[#991B1B] font-semibold">P90</div><div className="text-base font-bold text-[#991B1B]">{paybackP90?.toFixed(1) ?? '–'} jaar</div></div>
      </div>
      <ResponsiveContainer width="100%" height={180}>
        <AreaChart data={bins}><CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" /><XAxis dataKey="year" tick={{ fontSize: 10 }} /><YAxis tick={{ fontSize: 10 }} /><Tooltip formatter={(v: number) => [`${v}%`, 'Kans']} />
          {paybackP10 && <ReferenceLine x={Math.floor(paybackP10)} stroke="#16A34A" strokeDasharray="5 5" />}
          {paybackP50 && <ReferenceLine x={Math.floor(paybackP50)} stroke="#D97706" strokeDasharray="5 5" />}
          <Area type="monotone" dataKey="pct" stroke="#0891B2" fill="#0891B2" fillOpacity={0.3} isAnimationActive={!printMode} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
